import type { TrackingDisplayMode } from 'types/tracking.types';

/** MapLibre style JSON — default OpenFreeMap (not tile.openstreetmap.org). */
export const MAP_STYLE_URL =
  import.meta.env.VITE_MAP_STYLE_URL?.trim() ||
  'https://tiles.openfreemap.org/styles/liberty';

const modeEnv = import.meta.env.VITE_TRACKING_MODE?.trim() as
  | TrackingDisplayMode
  | 'auto'
  | undefined;

export const DEFAULT_TRACKING_MODE: TrackingDisplayMode | 'auto' =
  modeEnv === 'map' || modeEnv === 'simple' ? modeEnv : 'auto';

export const TRACKING_MODE_STORAGE_KEY = 'errandi.trackingMode';

export const ENABLE_ORDER_SSE =
  import.meta.env.VITE_ENABLE_ORDER_SSE !== 'false';
